import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { CatalogBin } from "../models/CatalogBin";

export const getCatalogBins = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[STEEL].[GetBins]", []);
};
export const upsertCatalogBin = async (bin: CatalogBin) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [];

  parameters.push({ name: "Id", value: bin.BinId });
  parameters.push({ name: "Name", value: bin.BinName });
  parameters.push({ name: "MaterialId", value: bin.MaterialId });
  parameters.push({ name: "Enabled", value: bin.Enabled });
  parameters.push({ name: "IsActive", value: bin.IsActive });

  return await apiService.callV2("[STEEL].[UpsertBin]", parameters);
};

export const deleteCatalogBin = async (BinId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [];
  parameters.push({ name: "BinId", value: BinId });

  return await apiService.callV2("[STEEL].[DeleteBin]", parameters);
};
